import React from "react";
import { Link } from "react-router-dom";

const dashboard = {
    eventCard: {
        'TodayTitle': 'Today\'s Event',
        'UpcomingTitle': 'Upcoming Events',
        'viewAllLinkText': 'View All',
        'viewAllUpcomingCelebrationText': 'View All',
        "birthday": {
            "key": 'birthdays',
            "icon": '🎂',
            "title": 'Birthdays',
            "emptyTodayTitle": "No Birthdays Today",
            "emptyUpcomingTitle": "No Birthdays for Upcoming",
            "emptyMessage": "Looks like everyone is getting older quietly today!",
            "emptyUpcomingMessage": "No upcoming birthdays to celebrate!"
        },
        "anniversary": {
            "key": 'workAnniversaries',
            "icon": '👔',
            "title": 'Work Anniversaries',
            "emptyTodayTitle": "No Anniversaries Today",
            "emptyUpcomingTitle": "No Anniversaries for Upcoming",
            "emptyMessage": "No milestones to cheer today!",
            "emptyUpcomingMessage": "No upcoming work anniversaries to celebrate!"
        },
        "customEvent": {
            "key": 'customEvent',
            "icon": '📅',
            "title": 'Events',
            "emptyTodayTitle": "No Events Today",
            "emptyUpcomingTitle": "No Events for Upcoming",
            "emptyMessage": "Nothing scheduled at the workplace today!",
            "emptyUpcomingMessage": "Nothing coming up soon. Stay tuned!"
        }
    },
    weatherCard: {
        "temperatureLabel": "Temperature",
        "windLabel": "Wind",
        "rainLabel": "Rain",
        "todayLabel": "Today",
        "tempUnit": "°C",
        "rainProbabilitySuffix": "%",
        "windUnit": "km/h"
    },
    attendanceWidget: {
        "AdminAttendanceWidget": {
            "title": 'Today Attendance',
            "viewAllRecordText": ' View Detailed Record',
            "totalEmployee": "Total Employees:",
            "presentLabel": "Present",
            "absentLabel": "Absent",
            "onLeaveLabel": "On Leave"
        },
        "EmployeeAttendanceWidget": {
            "employeeLogText": "Employee Log",
            "checkIn": {
                "title": "Checked In",
                "status": "checked-in",
                "message": "You have Checked In Successfully",
                "timeLabel": "Duration",
                "lastLabel": "Last Check-in",
                "buttonText": "Check Out"

            },
            "checkOut": {
                "title": "Checked Out",
                "status": "checked-out",
                "message": "You have Checked Out Successfully",
                "timeLabel": "Away for",
                "lastLabel": "Last Check-out",
                "buttonText": "Check In"
            },


        },
        "checkoutModal": {
            "title": "Checkout Confirmation",
            "message": " You are about to check out from your shift.\nPlease confirm to proceed.",
            "checkInLabel": "Check In",
            "durationLabel": "Duration",
            "checkOutButtonText": "Yes, Check Out",
            "cancelButtonText": "Cancel"

        }

    },

    notesCard: {
        "title": 'My Notes',
        "searchText": "Search notes...",
        "cancelButtonText": "Cancel",
        "submitButtonText": "Save Note",
        "editButtonText": "Edit",
        "deleteButtonText": "Delete",
        "notes": {
            "single": "Note",
            "multiple": "Notes"
        },
        "addNoteModal": {
            "title": {
                "edit": "Edit Note",
                "add": "Add Note",
                "view": "View Note"
            },
            "titleLabel": "Title",
            "titlePlaceholder": "Enter note title...",
            "contentLabel": "Content",
            "contentPlaceholder": "Enter note content..."
        }

    },

    pollVoteCard: {
        "title": 'Polls & Voting',
        "okButton": "Submit Vote",
        "emptyCardTitle": 'You\'re all caught up\n',
        "emptyCardContent": 'No polls need your input right now. New ones will show up here.',
        "emptyCardButton": 'View past polls'
    },

    adminPollVoteCard: {
        title: 'Polls & Voting',
        emptyCardTitle: 'No polls or votes yet',
        emptyCardContent: 'Once you create a poll or vote, it\'ll show up here with live results .' +
            ' Get started with whichever fits what you need from your team.',
        emptyCardButton: 'Create Poll',
        liveVotingDescription: 'Voting is currently in progress. Live results are hidden until voting ends.',
        responseCountLabel: 'response',
        noResponsesDescription: 'Responses will appear here once participants start voting.',
        viewFullBreakdownLabel: '+ {count} View full breakdown on Polls page',
        leadingOptionDescription: 'View full breakdown on Polls page',
        tiedLeadingOptionsLabel: 'Leading - {optCount} Options tied',
        moreLeadingOptionsLabel: '+{optCount} more options - full breakdown on Polls page',
        leadingOptionLabel: 'Leading - {option}'
    },

    articlesCard: {
        title: 'Knowledge Hub',
        description: 'Expand your knowledge with curated articles.',
        emptyCardTitle: 'Articles are on their way',
        emptyCardContent: ' We\'re gathering fresh content for you. Stay connected and check back soon.',
    }
}
export default dashboard
